<template>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-9 col-md-8">
      <div class="card shadow">
        <div class="card-header">
          Existing Members
        </div>
        <div class="card-body">
          <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
            <el-row :gutter="15">
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="Email address or username" prop="username">
                  <el-input v-model="form.username" name="username" :maxlength="32" placeholder="name@example.com"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="Password" prop="password">
                  <el-input v-model="form.password" name="password" type="password" :maxlength="32"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-button type="primary" native-type="submit" :loading="loading">Sign In</el-button>
            <el-button type="text" @click="$router.push({ name: 'reset' })">Recover Password</el-button>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      backend: process.env.VUE_APP_APP_HOST,
      form: {
        username: null,
        password: null,
      },
      rules: {
        'username': [
          { required: true, message: 'Enter your email address.', trigger: 'change' },
          { min: 3, message: 'This username is too short.', trigger: 'blur' },
          { max: 64, message: 'This username is too long.', trigger: 'blur' },
        ],
        'password': [
          { required: true, message: 'Enter your password.', trigger: 'change' },
          { min: 6, message: 'This password is too short', trigger: 'blur' },
          { max: 64, message: 'This password is too short', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          await this.$store.dispatch('login', {
            username: this.form.username,
            password: this.form.password,
          })
        } catch(err) {
          this.$message.error(err.message)
          return false
        } finally {
          this.loading = false
        }

        window.location.href = '/'
      })
    },
  },
}
</script>

<style scoped>
.join {
  background: #E3F2FD;
  border-top: 1px solid #BBDEFB;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
</style>
